allow-visible-on-all-workspaces:
  title: Cross-Space Visibility
  description: Allow the window to be visible on all workspaces, macOS only.
spotlight:
  errors:
    unknown: Unknown error
    prefix: 'Something went wrong: {message}'
    shortcutRegistrationFailed: 'Something went wrong: failed to register Spotlight shortcut.'
pages:
  modules:
    mcp-server:
      description: Connect and manage MCP server and tools
      title: MCP Server
  system:
    sections:
      section:
        window-shortcuts:
          title: Keyboard Shortcuts
    window-shortcuts:
      description: Modify the window shortcuts.
      title: Window Shortcuts
      empty: Not set
      spotlight:
        title: Spotlight shortcut
        description: Click the shortcut, then press a new shortcut. Press Esc to cancel.
      actions:
        recording: Press keys
        reset: Reset
      errors:
        load: Failed to load shortcut
        conflict: Shortcut already in use.
        failed: Failed to update shortcut
        requiresModifier: Use at least one of Cmd, Ctrl, Alt, or Super.
      toggle-move:
        label: Toggle Move
      toggle-resize:
        label: Toggle Resize
      toggle-ignore-mouse-event:
        label: Toggle Ignore Mouse Event
      press-keys: Press Keys...
    developer:
      sections:
        section:
          use-window-mouse:
            title: useWindowMouse Tool
            description: Test the Electron window cursor position
devtools:
  title: Developer
  pages:
    context-flow:
      title: Context Flow
    editor:
      title: AIRI Editor
      description: Open the standalone AIRI Editor window
      button: Open Editor
    lag-visualizer:
      title: Lag Visualizer
    performance-visualizer:
      title: Performance Visualizer
      description: Inspect live performance metrics and runtime diagnostics
      controls:
        enable-all:
          label: Enable all available metrics
          description: Enable each metric that this browser supports.
        start-recording: Start recording
        stop-recording: Stop recording ({seconds}s)
        export-last-recording: Export last recording
      metrics:
        fps:
          label: FPS
          description: Frames per second during the last 10 seconds.
        frame-duration:
          label: Frame time (ms)
          description: Time between animation frames during the last 10 seconds.
        long-task:
          label: Long tasks
          description: Main-thread tasks that take at least 50 ms.
          unsupported: This browser does not expose long-task timing.
        memory:
          label: JS heap (MB)
          description: JavaScript heap usage from Chromium's performance.memory API.
          unsupported: This browser does not expose JavaScript heap usage.
      recording:
        title: Last recording
        duration: Duration {duration} ms
        limit: Recording stops after 60 seconds.
      overlay:
        title: Performance
        move: Move performance overlay
        reset-position: Reset overlay position
        record: Record
        stop: Stop
        export: Export last recording
        average: avg
    markdown-stress:
      title: Markdown Stress
      description: Stress markdown parsing and rendering with heavy chat payloads
    io-tracer:
      title: IO Tracer
    widgets-calling:
      title: Widget Calling

screen-capture:
  permissions-prompt:
    title: Screen Capture
    description: To capture screens or windows, screen and system audio recording permissions are required.
    open-preferences: Open System Preferences
    dismiss: Dismiss
    instructions:
      step-1: Open "System Preferences", select "Privacy & Security" from the sidebar.
      step-2: In the "Screen & System Audio Recording" and "System Audio Recording Only" sections, turn on the switches for AIRI.
      step-2-note: If AIRI is not listed, please add it manually by clicking the "+" button and selecting AIRI from the Applications folder.
